import { render, staticRenderFns } from "./PikeIsAGuardian.vue?vue&type=template&id=53cef7a8&"
import script from "./PikeIsAGuardian.vue?vue&type=script&lang=js&"
export * from "./PikeIsAGuardian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports